import PageShell from "../components/PageShell";
import ImageResults from "../results/imageResults";

export default function ImageResultsPage() {
  return (
    <PageShell title="Photography Competition Results" bannerImage="join2.png">
      <ImageResults />
    </PageShell>
  );
}
